import React, { ReactElement, useEffect } from 'react';
import {
  SortLink, Table, Tbody, Th, Thead, Tr,
} from 'idsk-react-components';
import './sledovanyLegislativnyMaterialListTable.scss';
import SledovanyLegislativnyMaterialListTableRow from './SledovanyLegislativnyMaterialListTableRow';
import LegislativnyMaterialFilterListPage
  from '../../../../model/legislativnyMaterial/LegislativnyMaterialFilterListPage';
import routes from '../../../../routing/routes';
import useHistoryPageContext from '../../../../context/BreadcrumbContext/hook/useHistoryPageContext';

interface Props {
  legislativnyMaterialPage: LegislativnyMaterialFilterListPage;
  reloadMaterialPage: () => void;
}

const LegislativnyMaterialListTable = ({
  legislativnyMaterialPage,
  reloadMaterialPage,
}: Props): ReactElement => {
  const { setHistoryPages } = useHistoryPageContext();
  useEffect(() => {
    setHistoryPages([{ to: routes.procesy.sledovane, heading: 'Sledované procesy' }]);
  }, [setHistoryPages]);

  return (
    <div className="sledovany-legislativny-material-list__table">
      <Table>
        <Thead>
          <Tr>
            <Th width="15%" className="th-10">
              <SortLink
                propertyName="typPredpis"
                defaultDirection="asc"
                doubleArrows
              >Typ
              </SortLink>
            </Th>
            <Th width="10%" className="th-10">
              <SortLink
                propertyName="cisloLP"
                defaultDirection="asc"
                directionOfDefaultSort="desc"
                doubleArrows
              >
                Číslo LP
              </SortLink>
            </Th>
            <Th width="40%" className="th-40">
              <SortLink
                propertyName="nazov"
                defaultDirection="asc"
                doubleArrows
              >Názov
              </SortLink>
            </Th>
            <Th width="20%" className="th-20">
              <SortLink propertyName="stavPredpis" defaultDirection="asc" doubleArrows>
                Štádium
              </SortLink>
            </Th>
            <Th width="15%" className="th-15" />
          </Tr>
        </Thead>
        <Tbody>
          {legislativnyMaterialPage.materialList.map((material) => (
            <SledovanyLegislativnyMaterialListTableRow
              key={material.uuid}
              legMaterial={material}
              reloadMaterialPage={reloadMaterialPage}
            />
          ))}
        </Tbody>
      </Table>
    </div>
  );
};

export default LegislativnyMaterialListTable;
